import { basicEnum } from "./base";

export const PaymentStatusEnum = basicEnum([
    {
        label: "WAITING",
        value: "W",
    },
    {
        label: "SETTLED",
        value: "S",
    },
    {
        label: "EXPIRED",
        value: "E",
    },
]);

export namespace PaymentStatusEnum {
    export type Labels = (typeof PaymentStatusEnum)["labels"][number];
    export type Values = (typeof PaymentStatusEnum)["values"][number];
}
